import {
    type ReactElement,
    isValidElement,
    Children
} from "react";
import type {
    BreadcrumbEntriesConstantType,
    BreadcrumbEntryType
} from "../../type";
import type IBreadcrumbItemProps from "../item/type";
import type IBreadcrumbLinkProps from "../link/type";
import BreadcrumbLink from "../link";
import BreadcrumbPage from "../page";

type BreadcrumbContentElementType = ReactElement<Partial<IBreadcrumbLinkProps>>;

const isContentElement = (node: unknown): node is BreadcrumbContentElementType => {
    return isValidElement(node) && (node.type === BreadcrumbLink || node.type === BreadcrumbPage);
};

export const getBreadcrumbEntries = ({
    children
}: BreadcrumbEntriesConstantType): Array<BreadcrumbEntryType> => {
    const entries: Array<BreadcrumbEntryType> = [];

    Children.toArray(children).forEach((child, index) => {
        if(!isValidElement<IBreadcrumbItemProps>(child)) {
            return;
        }

        const content = Children.toArray(child.props.children).find(isContentElement);

        entries.push({
            isPage: content?.type === BreadcrumbPage,
            isDisabled: content?.props.isDisabled,
            title: content?.props.title ?? "",
            key: String(child.key ?? index),
            onPress: content?.props.onPress,
            href: content?.props.href,
            element: child
        });
    });

    return entries;
};
